import Vue from "vue";
import App from "./App.vue";
import Login from "./views/Login.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import axios from "axios";
import VueAxios from "vue-axios";
import "@babel/polyfill";
import "roboto-fontface/css/roboto/roboto-fontface.css";
import "@mdi/font/css/materialdesignicons.css";
import moment from "moment";
import VueMoment from "vue-moment";
import VueCookies from "vue-cookies";
import { Config } from "./config";
import '@/plugins/apexcharts.js'

Vue.use(VueCookies);
moment.locale("es");

Vue.use(VueAxios, axios);
Vue.use(VueMoment, { moment });

Vue.config.productionTip = false;

if (Config.env == "dev") {
  const userAuth = {
    id: "testing@kranon.com",
    fullName: "Testing",
    isAdmin: true
  };
  localStorage.setItem("userAuth", JSON.stringify(userAuth));
}

const root = document.getElementById("app");
if (root) {
  new Vue({
    router,
    store,
    vuetify,
    render: (h) => h(App),
  }).$mount(root);
}
const login = document.getElementById("login");
if (login) {
  new Vue({
    vuetify,
    render: (h) => h(Login),
  }).$mount(login);
}
